import { createSagas, bootSagas } from 'helpers/hotelModuleHelper';

import { actions, actionTypes } from '../actions/WebReputation';
import { selectors, DEFAULT_STATE } from '../reducers/WebReputation';
import api from '../apis/WebReputation';

const sagas = createSagas(
    'WebReputation',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = bootSagas(sagas, actionTypes);

export default [...defaultSagas];
